export var GdsgInventoryReportFormat;
(function (GdsgInventoryReportFormat) {
    GdsgInventoryReportFormat["GDSG_INVENTORY_REPORT_FORMAT_CSV"] = "CSV";
    GdsgInventoryReportFormat["GDSG_INVENTORY_REPORT_FORMAT_PARQUET"] = "PARQUET";
})(GdsgInventoryReportFormat || (GdsgInventoryReportFormat = {}));
